export default "__VITE_ASSET__Bco5rtNU__"